import { render } from "./index.vue?vue&type=template&id=b3e8b730"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
script.render = render

export default script